import React from "react";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import { Stack } from "@volca/ui/components/ui/stack";
import { formatDate } from "@/core/utils/date";
import { formatMoney } from "@/core/utils/money";
import { getCustomerNameOrPhone } from "@/customer/utils";
import { PayReferralButton } from "@/referrals/common/pay-referral-button";
import InfoPair from "./info-pair";
import { NameAndDate, NameAndDateSkeleton } from "./name-and-date";
import type { ReferralContentProps } from "./referralContent";

export const ClosedReferralCardSkeleton = () => (
  <Stack align="start" gap={4} className="w-full p-4">
    <NameAndDateSkeleton />
    <Stack className="w-full" align="start" gap={2}>
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-4 w-48" />
      <Skeleton className="h-4 w-24" />
    </Stack>
    <Skeleton className="h-7 w-full rounded-lg" />
  </Stack>
);

export interface ClosedReferralCardContentProps extends ReferralContentProps {
  onPayout: () => void;
  onLost?: () => void;
  onMoveToPaid?: () => void;
  onDelete?: () => void;
}

export const ClosedReferralCardContent = React.memo(
  ({
    referral,
    onPayout,
    onLost,
    onMoveToPaid,
    onDelete,
  }: ClosedReferralCardContentProps) => (
    <Stack align="start" gap={4} className="w-full p-4">
      <NameAndDate
        referral={referral}
        hideDate
        onLost={onLost}
        onMoveToPaid={onMoveToPaid}
        onDelete={onDelete}
      />
      <Stack className="w-full" align="start" gap={2}>
        <InfoPair
          label="Service date"
          info={formatDate(referral.appointment_date)}
        />
        <InfoPair
          label="Referred by"
          info={getCustomerNameOrPhone(referral.advocate)}
        />
        {/* The same full amount as the table's Deal size column. */}
        <InfoPair label="Deal size" info={formatMoney(referral.deal_size)} />
      </Stack>
      <PayReferralButton onPay={onPayout} className="w-full" />
    </Stack>
  ),
);
